export const CREATE_LIST_KEY = "audienceOverview.createListFlow";

export const AUDIENCE_ROUTE = "/account/engagement/audience";
export const CREATE_CAMPAIGN_ROUTE = "/account/engagement/create-campaign";

export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_FILE_ROWS = 50000;
export const CSV_EXTENSION = ".csv";
export const CSV_MIME_TYPE = "text/csv";
export const UPLOADED_LIST_TYPE = "list";

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export type CreateListStepKey = "upload" | "match" | "details" | "review";

export const CREATE_LIST_STEPS: Array<{ key: CreateListStepKey; titleKey: string }> = [
  { key: "upload", titleKey: `${CREATE_LIST_KEY}.steps.upload` },
  { key: "match", titleKey: `${CREATE_LIST_KEY}.steps.match` },
  { key: "details", titleKey: `${CREATE_LIST_KEY}.steps.details` },
  { key: "review", titleKey: `${CREATE_LIST_KEY}.steps.review` },
];

export type ListFieldKey = "email" | "firstName" | "lastName" | "phone";

export interface ListFieldConfig {
  key: ListFieldKey;
  labelKey: string;
  required: boolean;
  formField: string;
  hintKey?: string;
}

export const LIST_FIELDS: ListFieldConfig[] = [
  { key: "email", labelKey: `${CREATE_LIST_KEY}.fields.email`, required: true, formField: "email_address" },
  { key: "firstName", labelKey: `${CREATE_LIST_KEY}.fields.firstName`, required: true, formField: "first_name" },
  { key: "lastName", labelKey: `${CREATE_LIST_KEY}.fields.lastName`, required: false, formField: "last_name" },
  {
    key: "phone",
    labelKey: `${CREATE_LIST_KEY}.fields.phone`,
    required: false,
    formField: "phone_number",
    hintKey: `${CREATE_LIST_KEY}.fields.phoneHint`,
  },
];

export type ColumnMapping = Record<ListFieldKey, string | null>;

export const EMPTY_MAPPING: ColumnMapping = {
  email: null,
  firstName: null,
  lastName: null,
  phone: null,
};
